var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"share-btn",on:{"click":_vm.click}},[_c('icon',{staticStyle:{"margin-right":"5px"},attrs:{"type":"line","width":"14","height":"14"}}),_vm._v(_vm._s(_vm.$t('SHARE_BY_LINE')))],1)}
var staticRenderFns = []

export { render, staticRenderFns }